import { customElement, property } from 'lit/decorators.js';
import './list.scss'
import { style } from './list.styles';
import {html, LitElement} from 'lit';


@customElement('sbk-list')
export class SbkList extends LitElement {

    @property()
    size?: 'xs' | 'sm' | 'md' | '' = '';

    @property({ type: String })
    variant: 'ul' | 'ol' | 'none' | 'checkmark' = 'ul';

    static styles = style;

    render() {
        return (
            this.variant === 'ol' ?
                html`<ol class="list list--${this.size}"><slot></slot></ol>` :
                html`<ul class="list list--${this.size} list--${this.variant}"><slot></slot></ul>`
        );
    }
}